import axios from "axios";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useCallback, useEffect, useState } from "react";
import { FaSearch, FaTimes } from 'react-icons/fa';
import CountryList from "./CountryList";
import RegionList from "./RegionList";
import { getApiHeader, debounce } from 'utlis/commonfunctions';
import { useSoftUIController, setMiniSidenav } from "context";


import banner from "assets/images/international_esim_banner.png";
import GlobalPlans from "./GlobalPlans";
import { useNavigate } from "react-router-dom";
import esimBanner from "../../../assets/images/EsimBanner.png"


const SERVER_URL = process.env.REACT_APP_API_URL;


function InternationalEsim() {

    const [controller, dispatch] = useSoftUIController();

    const [countries, setCountry] = useState([]);
    const [regions, setRegions] = useState([])
    const [globalPlansList, setGlobalPlansList] = useState([]);
    const [query, setQuery] = useState('');
    const [searchData, setSearchData] = useState([]);
    const [redirectionType , setRedirectionType] = useState()
    const [retailerType , setRetailerType] = useState("PID");
    const [isLoading, setIsLoading] = useState(true);
    const [types, setType] = useState('local');
    const handleTypeChange = (type) => {
        setType(type);
    }
    const navigate = useNavigate();


    const fetchCountries = async (query) => {
        const headers = await getApiHeader();
        setIsLoading(true);

        try {
            const response = await axios.post(`${SERVER_URL}international-esim/search-countries`, {
                key_word: query,
            }, {
                headers: headers,
            });

            console.log(response.data.country_list);

            if (response.data.message === "success" && response.data) {

                setSearchData(response.data.country_list || []);
                setRedirectionType(response.data.country_type)
                console.log("searhData.------>", searchData);

            } else {
                console.error('Error:', message || 'Unexpected response structure');
                setSearchData([]); // Fallback to an empty array
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setSearchData([]);
        } finally {
            setIsLoading(false);
        }
    };
    const debouncedFetchCountries = useCallback(debounce(fetchCountries, 700), []);

    const handleSearch = (e) => {
        const query = e.target.value;
        setQuery(query);
        debouncedFetchCountries(query);
    };

    const handleClear = () => {
        setQuery('');
        setData([]);
    };

    const itemClickHandler = async (item) => {
        
        if(redirectionType === "country"){
            navigate("country_wise_plans", { state: { "country":item } });
        }else if (redirectionType === "region"){

            const region = {
            region_id: item.country_id, 
            region_slug: item.country_name_slug, 
            region_name: item.country_name, 
            region_flag: item.flag_image, 
        };

        navigate("region_wise_plans", { state: { region } });
    }
        
        
    }

    const getCountriesList = async () => {
        const headers = await getApiHeader();
        setIsLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 2000));
            const res = await axios.get(`${SERVER_URL}international-esim/countries`, {
                headers: headers
            });

            if (res.status === 200) {

                setCountry(res.data.country_list);
            } else {
                console.log("Error: Unexpected status code", res.status);
            }
        } catch (error) {
            console.error("Error fetching country list:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getRegionsList = async () => {
        const headers = await getApiHeader();
        setIsLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 2000));
            const res = await axios.get(`${SERVER_URL}international-esim/regions`, {
                headers: headers
            });

            if (res.status === 200) {
                setRegions(res.data.region_list);
            } else {
                console.log("Error: Unexpected status code", res.status);
            }
        } catch (error) {
            console.error("Error fetching region list:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getGlobalPlanList = async () => {
        const headers = await getApiHeader();
        setIsLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 2000));
            const res = await axios.get(`${SERVER_URL}international-esim/plans/global-esims`, {
                headers: headers
            });

            if (res.status === 200) {

                console.log("res.data.data---------->",res.data.data);
                
                setGlobalPlansList(res.data.data.plans);
                setRetailerType(res.data.data.retailer_type)
            } else {
                console.error("Error: Unexpected status code", res.status);
            }
        } catch (error) {
            console.error("Error fetching country list:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (countries.length === 0) {
            getCountriesList();
        }
        if (regions.length === 0) {

            getRegionsList()

        }
        if (globalPlansList.length === 0) {

            getGlobalPlanList()

        }
        
        // function handleMiniSidenav() {
            setMiniSidenav(dispatch, window.innerWidth < 1200 ? close : null);
        //   }
      
        //   /** 
        //    The event listener that's calling the handleMiniSidenav function when resizing the window.
        //   */
        //   window.addEventListener("resize", handleMiniSidenav);
      
        //   // Call the handleMiniSidenav function to set the state with the initial value.
        //   // handleMiniSidenav();
      
        //   // Remove event listener on cleanup
        //   return () => window.removeEventListener("resize", handleMiniSidenav);

    }, [])


    return (<>
        <DashboardLayout>
            <DashboardNavbar />
            <div className="international">
                <section id=" esim-hero-3" className="esim-hero-3 d-flex align-items-center">
                    <img
                        src={esimBanner}
                        alt="eSIM Banner"
                        className="esim-hero-background"
                        aria-hidden="true"
                    />
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 d-flex flex-column justify-content-center">
                                <div className="hero-header">
                                    <h2>Unleash the Power of Connectivity:</h2>
                                    <h1 className="gradient-header" data-text="Unbeatable 5G!">
                                        Shop eSIM Now!
                                    </h1>
                                    {/* <h5>Check out the best eSIM for traveling in Australia.</h5> */}
                                </div>

                                <center><div className="search-bar-container-2">
                                    <input
                                        type="text"
                                        value={query}
                                        onChange={handleSearch}
                                        isLoading={isLoading}
                                        placeholder="Search data packs for 200+ countries and regions"
                                    />
                                    <button type="submit">Search</button>
                                </div>
                                    {searchData.length > 0 && (
                                        <div className="data-display">
                                            <ul>
                                                {searchData.map((item) => (
                                                    <li key={item.country_id} onClick={() => itemClickHandler(item)}>
                                                        <img
                                                            src={item.flag_image}
                                                            alt={`Flag of ${item.country_name}`} // Use a meaningful alt attribute
                                                            title={item.country_name} // Use country_name for the title attribute
                                                        />
                                                        <span translate="no">{item.country_name}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </center>
                            </div>
                            
                        </div>
                    </div>
                </section>

                <div className="country-listing container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 country-tab">
                            <div className="row">
                                <div className="col-md-12 tab-button">

                                    <ul className="nav nav-tabs justify-content-center tab-button">
                                        <li className="nav-item">
                                            <a className={types === 'local' ? 'nav-link active' : 'nav-link'} onClick={() => handleTypeChange('local', '')}>Local eSIMs</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={types === 'regional-esim' ? 'nav-link active' : 'nav-link'} onClick={() => handleTypeChange('regional-esim', '')}>Regional eSIMs</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={types === 'global-esim' ? 'nav-link active' : 'nav-link'} onClick={() => handleTypeChange('global-esim')}>Global eSIMs</a>
                                        </li>
                                    </ul>
                                    {
                                        types === 'local' ? (
                                            <CountryList onCountryClick={handleTypeChange} countries={countries} isLoading={isLoading} />
                                        ) : types === 'regional-esim' ? (
                                            <RegionList onCountryClick={handleTypeChange} regions={regions} isLoading={isLoading} />
                                        )
                                            : types === 'global-esim' ? (
                                                <GlobalPlans plansList={globalPlansList} isLoading={isLoading} retailerType={retailerType} />
                                            )
                                                : null
                                    }
                                </div>
                            </div>
                        </div></div></div>
            </div>

        </DashboardLayout>
    </>)
}

export default InternationalEsim;